import React from 'react';
import { withRouter} from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import EarlyAccessCTA from 'component/content/early_access';
import Portfolio from 'component/content/portfolio';
import Popular from 'component/content/popular';
import Custom from 'component/content/custom';



class Page extends React.Component {
  // constructor(props){
  //   super(props);
  //   const {portfolio_xid} = this.props.match.params;
    
  //   this.state = {
  //     portfolio_xid: portfolio_xid,
  //   }
  // }

  // componentDidUpdate(){
  //   const {portfolio_xid} = this.props.match.params;
    
  //   const state = this.state;
  //   state.portfolio_xid = portfolio_xid;
  //   this.setState(state);
  // }

  render (){
    const {portfolio_xid} = this.props.match.params;
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <Portfolio portfolio_xid={portfolio_xid}/>

        <div className="bg-secondary my-5">
        <Custom />
        </div>

        <Popular />

        <div className="bg-dark">
          <EarlyAccessCTA text_colour="white"/>
        </div>


      </LandingLayout>
    )
  }
}

export default withRouter(Page);
